/* eslint-disable */
import ko from 'knockout';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
var ViewModel = function () {
  this.isCampaignTargetsExpanded = ko.observable(false);
  this.BidStrategy = ko.observable();
  this.isCampaignLevelGoalEnabled = ko.observable(false);
  this.isbiddingStrategyTypeCPC = ko.observable(true);
  ko_schema.properties(this);
  this.hasChanges = ko.observable(false);
  this.estimateTrafficSupported = ko.observable(false);
  this.showPerformanceGrid = ko.computed(function () {
    return this.estimateTrafficSupported() && this.isbiddingStrategyTypeCPC();
  }, this);
  this.showAdgroupBidGrid = ko.computed(function () {
    return !this.showPerformanceGrid() && this.isbiddingStrategyTypeCPC();
  }, this);
};
export default ViewModel;

